export default "__VITE_ASSET__D4$R5QMq__"